import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../state/context";

import './categories-left-panel.styles.scss';
import useFetch from "../../api/fetch";
import Category from "../category/category.component";



export default function CategoriesLeftPanel() {
    const { state, dispatch } = useContext(Context);
    const fetch = useFetch();
    const [categories, setCategories] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [showMarketing, setShowMarketing] = useState(false);
    const [search, setSearch] = useState("");

    useEffect(() => {
        setFilteredCategories(state.categories);
        setCategories(state.categories);
        dispatch({type: 'SET_ACTIVE_CATEGORY', activeCategory: state.categories[0]});
    }, [state.categories]);

    useEffect(() => {
        if (filteredCategories.length > 0) {
            dispatch({type: 'SET_ACTIVE_CATEGORY', activeCategory: filteredCategories[0]});
        }
    }, [filteredCategories]);

    useEffect(() => {
        var filtered = categories.filter(({ name }) => name.toLowerCase().includes(search.toLowerCase()));
        if(showMarketing) {
            filtered = filtered.filter(({is_marketing}) => is_marketing > 0);
        }
        setFilteredCategories(filtered);
    }, [search, showMarketing]);

    return (
        <div className="d-flex flex-column col-6">
            <div className="d-flex align-items-center justify-content-between mb-3">
                <h6>Category list</h6>
            </div>
            <div className="d-flex align-items-center justify-content-between mb-3 row">
                <div className="input-group search-field col-9">
                    <input className={"form-control shadow-none border-right-0"}
                        placeholder={"Search"}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)} />
                    <div className="input-group-append">
                        <span className={"input-group-text bg-transparent border-left-0"}><i className="fas fa-search"></i></span>
                    </div>
                </div>
                <div className="custom-control custom-checkbox col-3 d-flex justify-content-end">
                    <input type="checkbox" className="custom-control-input" id="onlyMarketing" onChange={(e) => setShowMarketing(e.target.checked)}/>
                    <label className="custom-control-label" htmlFor="onlyMarketing">Show only marketing</label>
                </div>
            </div>
            <div className="categories-column">
                {filteredCategories.map((category, index) => (
                    <Category data-position={index}
                        key={category.id}
                        category={category} />
                ))}
            </div>

        </div>
    )
}
